import { useLang } from '../i18n';
import { getCountries, getCountryCallingCode, type CountryCode } from 'libphonenumber-js/min';

/** 🇻🇳 from "VN". */
export const flag = (code: string) => String.fromCodePoint(...[...code.toUpperCase()].map((c) => 0x1f1a5 + c.charCodeAt(0)));

const names = new Map<string, Intl.DisplayNames>();
export function countryName(code: string): string {
  const lang = useLang.getState().lang;
  try {
    if (!names.has(lang)) names.set(lang, new Intl.DisplayNames([lang, 'en'], { type: 'region' }));
    return names.get(lang)!.of(code) ?? code;
  } catch {
    return code;
  }
}

export interface CountryOption {
  code: CountryCode;
  name: string;
  dial: string;
}

const cached = new Map<string, CountryOption[]>();
/** Every country with a phone calling code, sorted by name in the app's language (Vietnam first). */
export function countries(): CountryOption[] {
  const lang = useLang.getState().lang;
  if (!cached.has(lang)) {
    cached.set(
      lang,
      getCountries()
        .map((code) => ({ code, name: countryName(code), dial: `+${getCountryCallingCode(code)}` }))
        .sort((a, b) => (a.code === 'VN' ? -1 : b.code === 'VN' ? 1 : a.name.localeCompare(b.name, lang))),
    );
  }
  return cached.get(lang)!;
}
